var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2309 4.001 6.6384 6.9638c-.7273.8313-1.9909.9155-2.8221.1882a1.9998 1.9998 0 0 1-.1882-.1882L1.0357 4.001c-.7274-.8313-.6432-2.0948.1881-2.8222A2 2 0 0 1 2.5408.684h5.185c1.1045 0 2 .8954 2 2a2 2 0 0 1-.495 1.317Z",
    fill: "#9DA1AD",
    fillRule: "evenodd",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDd);
export default __webpack_public_path__ + "static/media/dd.c02fc22e51e7ac4e9405f8bbe196788d.svg";
export { ForwardRef as ReactComponent };